export { default as formatData } from './format-data'
export { default as getColor } from './get-color'
